import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";

import { NavLink } from "react-router-dom";

import { replace_string, server_django } from "../../../util";
import SpinnerMini from "../../../UI/SpinnerMini";
import useFacultyMembers from "../../../features/useFacultyMembers";

function FacultyMembers({ config }) {
  const [responsive, setResponsive] = useState({
    0: {
      items: 1,
    },
    450: {
      items: 2,
    },
    600: {
      items: 2,
    },
    1000: {
      items: 4,
    },
  });

  const { facultyMembers: data, loading } = useFacultyMembers();

  if (loading) return <SpinnerMini />;

  const facultymembers = data?.filter(
    (item) =>
      item.department.some(
        (item) => item.depid === Number(config?.department)
      ) &&
      (item.job_type_id.id === Number(config?.full) ||
        item.job_type_id.id === Number(config?.contractual))
  );

  return (
    <div id="FacultyMembers">
      <div className="title text-left">
        <p className="heading3">Faculty Members</p>
      </div>

      {facultymembers?.length > 3 && (
        <OwlCarousel
          className="owl-theme"
          loop
          margin={10}
          autoPlay={true}
          responsive={responsive}
        >
          {facultymembers?.map((facultymembersList) => {
            return (
              <div className="item" key={facultymembersList.id}>
                <FacultyMember
                  facultyMember={facultymembersList}
                  key={facultymembersList.id}
                />
              </div>
            );
          })}
        </OwlCarousel>
      )}
      {facultymembers?.length > 0 && facultymembers?.length <= 3 && (
        <div className="item departmentCard">
          {facultymembers?.map((facultymembersList) => (
            <FacultyMember
              facultyMember={facultymembersList}
              key={facultymembersList.id}
            />
          ))}{" "}
        </div>
      )}
    </div>
  );
}

export default FacultyMembers;

function FacultyMember({ facultyMember }) {
  return (
    <div className="card">
      <NavLink exact to={"/facultyMemberDetails/" + facultyMember.id}>
        <img
          className="img-fuild faculty__member"
          src={facultyMember.staff_picture.replace(
            replace_string,
            server_django
          )}
          alt={facultyMember.staff_name}
        ></img>

        <div className="card-body">
          <p className="heading6">{facultyMember.staff_name}</p>
          <p className="allText text-center">
            {facultyMember.designation.designation}{" "}
          </p>
        </div>
      </NavLink>
    </div>
  );
}
